/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Platform_Plan_Day_CInputs */

const en_platform_plan_day_c = /** @type {(inputs: Platform_Plan_Day_CInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Day C`)
};

const pl_platform_plan_day_c = /** @type {(inputs: Platform_Plan_Day_CInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dzień C`)
};

/**
* | output |
* | --- |
* | "Day C" |
*
* @param {Platform_Plan_Day_CInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const platform_plan_day_c = /** @type {((inputs?: Platform_Plan_Day_CInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Platform_Plan_Day_CInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_platform_plan_day_c(inputs)
	return en_platform_plan_day_c(inputs)
});